<q-file-browser
  *ngIf="responseReceived"
  [class.bc-visible]="breadcrumbVisible"
  [showCompany]="showCompany"
  [fundsRequired]="fundsRequired"
  [rawFiles]="rawFiles"
  [funds]="funds"
  [portfolioCompanies]="portfolioCompanies"
  [mnemonic]="mnemonic"
  [existingDealNames]="finalDealNamesForDropdown"
  [dealNames]="dealNamesForBrowser"
  (deleteFile)="deleteFile($event)"
  (downloadFile)="downloadFile($event)"
  (downloadFiles)="downloadFiles($event)"
  (uploadFile)="uploadFile($event)"
  (viewFile)="viewFile($event)"
  (viewVersionHistory)="viewVersionHistory($event)"
  (copyLink)="copyLink($event)"
  (toggleBreadCrumb)="toggleBreadCrumb($event)">
</q-file-browser>


<p-dialog [contentStyle]="{'overflow': 'visible'}" [(visible)]="isVersionHistoryVisible" [modal]="true" [style]="{width: '1024px'}" *ngIf="versionHistory">
    <app-version-history [historyData]="versionHistory.value"
        [attachment]="versionHistory.attachment"
        (downloadHistory)="downloadVersionTemplate($event)"
        (cancelled)="closeVersionHistory()">
    </app-version-history>
</p-dialog>